import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navItems } from '@/mocks/navigation';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-600 transition-colors duration-200"
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
              17
            </div>
            <span className="font-heading font-bold text-xl hidden sm:block">17c 平台</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`relative px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(item.href)
                    ? 'text-primary-700 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200/70'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/guide"
              className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              登录
            </Link>
            <Link
              to="/article/register-login"
              className="px-5 py-2 text-sm font-medium rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              免费注册
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200/70 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                  isActive(item.href)
                    ? 'text-primary-700 bg-primary-100/70'
                    : 'text-foreground-700 hover:bg-background-200/70'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="flex items-center gap-3 mt-2 pt-3 border-t border-background-200/70">
              <Link
                to="/category/guide"
                className="flex-1 text-center py-2.5 text-sm font-medium rounded-lg border border-background-300/60 text-foreground-700 hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                登录
              </Link>
              <Link
                to="/article/register-login"
                className="flex-1 text-center py-2.5 text-sm font-medium rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
              >
                免费注册
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}